var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { renderFont } from '../ThemeProvider';
import textTheme from './theme';
var getFontSize = function (fontSize, large, small) {
    if (large) {
        return fontSize.large;
    }
    if (small) {
        return fontSize.small;
    }
    return fontSize.medium;
};
/** Text */
export var Text = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  line-height: ", ";\n"], ["\n  line-height: ",
    ";\n"])), function (_a) {
    var lineHeight = _a.theme.component.text.lineHeight, large = _a.large, small = _a.small;
    return getFontSize(lineHeight, large, small);
});
/** P */
var StyledP = styled(Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: ", ";\n  font-size: ", ";\n  ", "\n"], ["\n  margin-bottom: ", ";\n  font-size: ",
    ";\n  ", "\n"])), function (_a) {
    var component = _a.theme.component;
    return component.text.margin.small;
}, function (_a) {
    var fontSize = _a.theme.component.text.fontSize, large = _a.large, small = _a.small;
    return getFontSize(fontSize, large, small);
}, function (_a) {
    var theme = _a.theme;
    return renderFont('base', 'normal', theme);
});
export var P = function (props) { return (React.createElement(ThemeProvider, { theme: textTheme },
    React.createElement(StyledP, __assign({}, props, { as: "p" })))); };
/** Em */
var StyledEm = styled(Text)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: ", ";\n  font-size: ", ";\n  ", "\n"], ["\n  margin-bottom: ", ";\n  font-size: ",
    ";\n  ", "\n"])), function (_a) {
    var component = _a.theme.component;
    return component.text.margin.small;
}, function (_a) {
    var fontSize = _a.theme.component.text.fontSize, large = _a.large, small = _a.small;
    return getFontSize(fontSize, large, small);
}, function (_a) {
    var theme = _a.theme;
    return renderFont('base', 'normal', theme);
});
export var Em = function (props) { return (React.createElement(ThemeProvider, { theme: textTheme },
    React.createElement(StyledEm, __assign({}, props, { as: "em" })))); };
/** Strong */
var StyledStrong = styled(Text)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-bottom: ", ";\n  font-size: ", ";\n  ", "\n"], ["\n  margin-bottom: ", ";\n  font-size: ",
    ";\n  ", "\n"])), function (_a) {
    var component = _a.theme.component;
    return component.text.margin.small;
}, function (_a) {
    var fontSize = _a.theme.component.text.fontSize, large = _a.large, small = _a.small;
    return getFontSize(fontSize, large, small);
}, function (_a) {
    var theme = _a.theme;
    return renderFont('base', 'bold', theme);
});
export var Strong = function (props) { return (React.createElement(ThemeProvider, { theme: textTheme },
    React.createElement(StyledStrong, __assign({}, props, { as: "strong" })))); };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map